<!-- 快速求购页面 -->
<template>
  <div class="container">
    <div class="header">我的求购信息</div>
    <div class="timeselect">
      <el-row :gutter="24">
        <el-col
          :span="5"
        ><div class="grid-content bg-purple">
          <div class="quotation">
            <!-- <span>报价情况：</span> -->
            <el-select v-model="offerValue" placeholder="请选择">
              <el-option
                v-for="item in offerData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div></div></el-col>
        <el-col
          :span="5"
        ><div class="grid-content bg-purple">
          <div class="timeStatus">
            <!-- <span>到期状态：</span> -->
            <el-select v-model="expireValue" placeholder="请选择">
              <el-option
                v-for="item in expireData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div></div></el-col>
        <el-col
          :span="5"
        ><div class="grid-content bg-purple">
          <div class="maiTime">
            <!-- <span>发布时间：</span> -->
            <el-date-picker
              v-model="releaseTime"
              type="date"
              placeholder="选择发布日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
            />
          </div></div></el-col>
        <el-col
          :span="5"
        ><div class="grid-content bg-purple">
          <div class="maiTime">
            <!-- <span>到货截止时间：</span> -->
            <el-date-picker
              v-model="arrivalTime"
              type="date"
              placeholder="选择到货截至日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
            />
          </div>
        </div>
        </el-col>
        <el-col
          :span="4"
        ><div class="grid-content bg-purple">
          <div class="maiTime">
            <el-button
              style="margin-left: 20px"
              @click="pageNo = 1 , serData()"
            >查询</el-button>
            <el-button
              v-if="rols('我要发布')"
              style="margin-left: 20px"
              @click="issueButton()"
            >我要发布</el-button>
            <!-- <div class="issueButton" @click="issueButton()">我要发布</div> -->
          </div>
        </div>
        </el-col>
      </el-row>
    </div>
    <!-- <div class="Purchasing-information">
      <div v-for="(item, index) in list" :key="index" class="Purchasing-details">
        <el-carousel height="218px" :autoplay="false">
          <el-carousel-item v-for="(fileObj,i) in item.fimages" :key="i">
            <el-image
              style="width: 100%; height: 100%;object-fit: cover;"
              :src="fileObj.fimagePath"
              :preview-src-list="[fileObj.fimagePath]"
            />
          </el-carousel-item>
        </el-carousel>
        <div style="height:101px;padding:12px 14px 8px;">
          <p style="height:54px;line-height:27px;">
            {{ item.fpurchaseInfo }}
          </p>
          <div style="height:27px;line-height:27px;">
            <div style="float:left;color: rgb(132, 138, 154);font-size:14px;">
              {{ item.farriveDateTime }}
            </div>
            <div class="dataTime">
              <div class="right-triangle" />
              <div style="text-align: center;width:100%;margin-left: -13px;">
                距离到货截至日期还有12天
              </div>
            </div>
          </div>
        </div>
        <div class="address-see">
          <div style="float:left;">
            <svg-icon icon-class="new-address" />
            {{ newAreaName(item.fareaName) }}
          </div>
          <div style="float:right;">
            {{ item.fbrowseCount }}次
          </div>
        </div>
        <div class="info-price">
          <img src="../../../assets/images/no-pic.jpg" alt="">
          <span style="width:85px;">
            {{ item.fcreator }}
          </span>
          <svg-icon style="margin-right:8px;" icon-class="new-phone" />
          <span style="width:92px;">
            {{ item.ftelNo }}
          </span>
          <span style="color: rgb(236, 33, 45);margin-left:10px;">
            你有8条报价信息
          </span>
          <span class="seePriceInfo">
            查看报价信息
          </span>
        </div>
      </div>
    </div> -->
    <div v-for="(item, index) in list" :key="index" class="productList">
      <div class="publisher">
        <span>发布人： {{ item.fcreator }}</span>
        <span>发布时间： {{ item.fcreateTime }}</span>
        <!-- <span>截止日期： {{ item.expityDate }}</span> -->
        <span>到货截止日期：{{ item.farriveDateTime }}</span>
        <img
          :src="
            item.isoutofDate
              ? require('@/assets/images/jiaobiao-guoqi.png')
              : require('@/assets/images/jiaobiao-jinxingzhong.png')
          "
        >
      </div>
      <div class="buyContent">
        <svg-icon :icon-class="item.isoutofDate ? 'laba-hui' : 'laba'" />
        <span class="content"> {{ item.fpurchaseInfo }}</span>
        <div class="shopImg">
          <el-image
            v-for="(img, val) in item.fimages"
            :key="val"
            :src="img.fimagePath"
            alt=""
            :preview-src-list="[img.fimagePath]"
          />
        </div>
        <div class="contact">
          <div>联系人： {{ item.flinkman }}</div>
          <div>联系电话：{{ item.ftelNo }}</div>
          <div>收货城市： {{ item.fareaName }}</div>
          <div>
            <svg-icon icon-class="liulan" />
            已浏览次数：{{ item.fbrowseCount }}次
            <div class="isTabButton" @click="tabButton(item, index)">
              <i :class="item.show ? iconDown : iconUp" />
            </div>
          </div>
        </div>
      </div>

      <div v-if="index == isTableShow" class="poductTab">
        <el-table
          :header-cell-style="{
            background: 'rgba(236, 33, 45, 0.1)',
            color: '#555',
            borderRight: '1px solid #EC212D',
            borderBottom: '1px solid #EC212D',
            fontSize: '14px',
            color: ' #EC212D',
            fontWeight: '400',
          }"
          :data="item.forderPrices"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="fproviderAreaName"
            label="发货城市"
            align="center"
          />
          <el-table-column
            prop="fstockName"
            label="商品名称"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <span class="shopName" @click="godetils(scope.row)">{{
                scope.row.fstockName
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="ftotalPrice" label="单价" align="center" />
          <el-table-column prop="fcreateTime" label="报价时间" align="center" />
          <el-table-column prop="fdays" label="到货时间" align="center" />
          <el-table-column prop="flinkman" label="联系人" align="center" />
          <el-table-column prop="ftelNo" label="联系电话" align="center" />
          <el-table-column
            prop="fpriceContent"
            label="备注"
            align="fpriceContent"
          />
        </el-table>
      </div>
    </div>

    <!-- 点击我要发布后的弹窗 -->
    <el-dialog
      title="发布求购信息"
      center
      :visible.sync="dialogFormVisible"
      @close="handleClose('ruleForm')"
    >
      <el-form ref="ruleForm" :model="messgeForm" :rules="rules">
        <el-form-item label="输入求购信息" label-width="110px" prop="name">
          <el-input
            v-model.trim="messgeForm.name"
            type="textarea"
            autocomplete="off"
            maxlength="100"
            resize="none"
          />
        </el-form-item>
        <el-form-item label="上传商品图片" label-width="110px">
          <div v-if="messgeForm.picture">
            <div
              v-for="(item, index) in messgeForm.picture"
              :key="index"
              class="imgbox"
            >
              <img :src="item.url" class="avatar">
              <span class="icon el-icon-error" @click="handleRemove(index)" />
            </div>
          </div>
          <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :auto-upload="false"
            action="Fake Action"
            :on-change="handleChange"
            :before-upload="otherSectionFile"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="到货截止时间" label-width="110px" prop="time">
              <el-date-picker
                v-model="messgeForm.time"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人" label-width="110px" prop="peaple">
              <div @click="showshops(index)">
                <el-input
                  v-model="messgeForm.peaple"
                  suffix-icon="el-icon-search"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="收货城市"
              disabled
              label-width="110px"
              prop="city"
            >
              <el-input v-model="messgeForm.city" placeholder="" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="联系电话"
              disabled
              label-width="110px"
              prop="phone"
            >
              <el-input
                v-model.number="messgeForm.phone"
                maxlength="11"
                placeholder=""
              />
            </el-form-item>
          </el-col> </el-row></el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="onConfirm('ruleForm')"
        >确 定</el-button>
      </div>
      <el-dialog
        title="选择联系人"
        :visible.sync="responsibleShow"
        append-to-body
      >
        <div class="director">
          <div style="margin-bottom: 20px">
            <el-input
              v-model="directorSearch"
              style="width: 300px"
              placeholder="请输入内容"
              @keyup.enter.native="dirSearch"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-error"
                @click="clearDirectorSearch"
              />
            </el-input>
          </div>
          <div>
            <!--                @selection-change="directorSelectionChange"-->
            <el-radio-group v-model="directorSelection">
              <el-table
                ref="directorTable"
                :data="directorData"
                border
                tooltip-effect="dark"
                style="width: 720px"
                max-height="300px"
              >
                >
                <el-table-column label="" width="55" align="center">
                  <template slot-scope="scope">
                    <el-radio :label="scope.row.fid"><br></el-radio>
                  </template>
                </el-table-column>
                <el-table-column prop="fname" label="联系人名称" />
                <el-table-column prop="fphoneNo" label="联系人电话" />
                <el-table-column prop="fareaName" label="联系人地址" />
              </el-table>
            </el-radio-group>
            <div
              style="
                display: flex;
                justify-content: center;
                align-content: center;
                margin-top: 20px;
              "
            >
              <el-pagination
                layout="prev, pager, next"
                :page-size="20"
                :pager-count="8"
                :total="shoptotal"
                @current-change="directorCurrentChange"
              />
            </div>
          </div>
          <div style="margin-top: 40px; margin-bottom: 80px">
            <el-button
              size="mini"
              type="primary"
              style="float: right"
              @click="directorPreservation"
            >确 定
            </el-button>
            <el-button
              size="mini"
              style="float: right; margin-right: 20px"
              @click="responsibleShow = false"
            >取 消
            </el-button>
          </div>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>
<script>
import {
  providerPage,
  uploadImg,
  providerSave,
  mallUserAddress,
  publishData
} from '@/api/post-buy'
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
        }
      },
      releaseTime: '',
      arrivalTime: '',
      expireValue: '-1',
      offerValue: '-1',
      offerData: [
        {
          value: '-1',
          label: '全部'
        },
        {
          value: '0',
          label: '未报价'
        },
        {
          value: '1',
          label: '已报价'
        }
      ],
      expireData: [
        {
          value: '-1',
          label: '全部'
        },
        {
          value: '0',
          label: '未到期'
        },
        {
          value: '1',
          label: '已到期'
        }
      ],
      value: '',
      value1: '',
      // 搜索弹窗套装
      responsibleShow: false, // 商铺弹窗
      directorSearch: '',
      directorSelection: '',
      directorData: [],
      directorTotal: '',
      shoptotal: 0,
      directorAllData: [],
      shoppages: 1,
      shopindex: '',
      //
      pageNo: 1, // 分页
      pageSize: 15,
      list: [],
      dialogFormVisible: false, // 控制弹窗的显示隐藏
      isTableShow: -1, // 控制下拉
      tabIcon: 'el-icon-arrow-down',
      messgeForm: {
        name: '',
        time: '',
        peaple: '',
        city: '',
        phone: '',
        picture: []
      },
      fileList: [],
      limit: 6,
      uploadDisabled: false,
      iconDown: 'el-icon-arrow-down',
      iconUp: 'el-icon-arrow-up',
      rules: {
        name: [{ required: true, message: '请输入求购信息', trigger: 'blur' }],
        peaple: [
          { required: true, message: '请选择联系人', trigger: 'change' }
        ],
        city: [{ required: true, message: '请输入收货地址', trigger: 'blur' }],
        time: [
          { required: true, message: '请选择到货截止时间', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { type: 'number', message: '请输入正确的手机号', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    newAreaName() {
      return function(val) {
        return val.replaceAll('\\', '').replaceAll('所有地区', '')
      }
    },
    // 当前页操作权限
    rols() {
      const setting = this.$store.getters.pageSetting('快速求购')
      return function(val) {
        if (typeof setting === 'boolean') return true
        return setting.indexOf(val) > -1
      }
    }
  },
  created() {
    this.onsearch()
  },
  mounted() {
    // console.log(this.isTableShow)
  },
  methods: {
    serData() {
      const arr = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        jsonobj: {
          FStatus: this.offerValue,
          FType: this.expireValue,
          FPurchaseDate: this.releaseTime,
          FArriveDateTime: this.arrivalTime
        }
      }
      publishData(arr).then((res) => {
        this.list = res.rows
      })
    },
    godetils(val) {
      const routeUrl = this.$router.resolve({
        path: '/store/details',
        redirect: '',
        query: { mallstorestockFId: val.fstoreStockID }
      })
      window.open(routeUrl.href, '_blank')
    },
    // 搜索弹窗套件
    directorPreservation() {
      this.directorData.map((item) => {
        if (item.fid === this.directorSelection) {
          this.messgeForm.city = item.fareaName
          this.messgeForm.peaple = item.fname
          this.messgeForm.phone = item.fphoneNo
        }
      })
      this.responsibleShow = false
    },
    async directorCurrentChange(val) {
      // 分页
      this.shoppages = val
      mallUserAddress({
        pageNo: this.shoppages,
        pageSize: 20,
        keyword: this.directorSearch,
        FProviderUnitID: 0
      }).then((res) => {
        this.shoptotal = res.total
        this.directorData = res.rows
      })
    },
    async dirSearch() {
      // 搜索
      mallUserAddress({
        pageNo: this.shoppages,
        pageSize: 20,
        keyword: this.directorSearch,
        FProviderUnitID: 0
      }).then((res) => {
        this.shoptotal = res.total
        this.directorData = res.rows
      })
    },
    async clearDirectorSearch() {
      // 清空搜索框
      this.directorSearch = ''
      mallUserAddress({
        pageNo: this.shoppages,
        pageSize: 20,
        keyword: this.directorSearch,
        FProviderUnitID: 0
      }).then((res) => {
        this.shoptotal = res.total
        this.directorData = res.rows
      })
    },
    async showshops(index) {
      this.shopindex = index
      mallUserAddress({
        pageNo: this.shoppages,
        pageSize: 20,
        keyword: this.directorSearch,
        FProviderUnitID: 0
      }).then((res) => {
        this.shoptotal = res.total
        this.directorData = res.rows
        this.directorData.map((item) => {
          const a = item.fareaName.split(',')
          item.fareaName = a.join('/')
          item.fareaName = item.fareaName + '/' + item.faddress
        })
        this.responsibleShow = true
      })
    },
    //
    // 图片上传
    handleChange(file, fileList) {
      const formData = new FormData()
      formData.append('file', file.raw)
      uploadImg(formData).then((res) => {
        if (res.result) {
          this.messgeForm.picture.push(res.imgUrlList[0])
        }
      })
    },
    // 图片删除
    handleRemove(index) {
      this.messgeForm.picture.splice(index, 1)
    },
    //  渲染页面
    onsearch() {
      providerPage({ pageNo: this.pageNo, pageSize: this.pageSize }).then(
        (res) => {
          this.list = res.rows
          this.list.map((item, index) => {
            var enddata = Date.parse(new Date(item.farriveDateTime)) / 1000
            var newdata = Date.parse(new Date(item.fsysDate)) / 1000
            if (enddata < newdata) {
              item.isoutofDate = true
            } else {
              item.isoutofDate = false
            }
          })
        }
      )
    },
    //  点击了我要发布按钮
    issueButton() {
      this.dialogFormVisible = true
    },
    // 下拉展示
    tabButton(item, index) {
      item.show = !item.show
      if (item.show) {
        this.isTableShow = index
      } else {
        this.isTableShow = -1
      }
    },
    //  点击了确定按钮
    onConfirm(formName) {
      const dataMess = this.messgeForm
      if (
        dataMess.name != '' &&
        dataMess.name != '' &&
        dataMess.peaple != '' &&
        dataMess.time != ''
      ) {
        var token = JSON.parse(sessionStorage.getItem('vuex'))
        const a = this.messgeForm.city.split('/')
        const fimages = []
        this.messgeForm.picture.map((item) => {
          fimages.push({
            fid: 0,
            fimagePath: item.url,
            fpurchaseOrderInfoId: 0
          })
        })
        providerSave({
          fuserAddressID: this.directorSelection,
          fareaName: a[a.length - 2],
          farriveDateTime: this.messgeForm.time,
          fimages: fimages,
          ftelNo: this.messgeForm.phone,
          fpurchaseInfo: this.messgeForm.name,
          flinkman: this.messgeForm.peaple,
          token: token.user.token
        }).then((res) => {
          if (res.result) {
            this.$message({
              type: 'success',
              message: '新增成功!'
            })
            this.onsearch()
            this.dialogFormVisible = false
          }
        })
      } else {
        this.$message('请完善表格信息')
      }
    },
    // 关闭弹窗时触发
    handleClose(formName) {
      this.$refs[formName].resetFields()
      this.fileList = []
      this.messgeForm = {
        name: '',
        time: '',
        peaple: '',
        city: '',
        phone: [],
        picture: []
      }
    },
    // 图片上传前校验
    otherSectionFile(file, fileList) {
      this.uploadDisabled = fileList.length >= this.limit
      const typeArr = ['image/png', 'image/gif', 'image/jpeg', 'image/jpg']
      const isJPG = typeArr.indexOf(file.raw.type) !== -1
      const isLt3M = file.size / 1024 / 1024 < 3
      if (!isJPG) {
        this.$message.error('只能是图片!')
        this.$refs.upload.clearFiles()
        // this.otherFiles = null
        return
      }
      if (!isLt3M) {
        this.$message.error('上传图片大小不能超过 3MB!')
        this.$refs.upload.clearFiles()
        // this.otherFiles = null
        return
      }
      // console.log(file.raw)
      this.messgeForm.picture = fileList
      // this.otherFiles = file.raw
    }
  }
}
</script>
<style lang="scss">
.Purchasing-information {
    margin-top: 20px;
    .Purchasing-details {
        display: inline-block;
        width: 494px;
        height: 392px;
        background-color: rgb(245, 248, 251);
        margin-right: 25.5px;
        margin-bottom: 10px;
        &:nth-child(3n) {
            margin-right: 0;
        }
        .el-carousel__item.is-animating {
            display: flex;
            justify-content: center;
        }
        p {
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;//此处为行数，可以改为任意数字
            color: rgb(102, 105, 113);
            font-size: 16px;
            font-weight: 500
        }
        .dataTime {
            display: flex;
            float: right;
            width: 195px;
            height: 26px;
            background: linear-gradient(to right, rgba(255,55,55,255) 2.171%,rgba(243,55,140,255) 100%,rgba(243,55,140,255) 100%);
            text-align: center;
            color: #fff;
            font-size: 12px;
            margin-right: -14px;
            .right-triangle {
                width: 0;
                height: 0;
                border:13px solid transparent;
                border-left-color:rgb(245, 248, 251);
            }
        }
        .address-see {
            height: 21px;
            line-height: 21px;
            padding: 0 14px;
            font-size: 14px;
            color: rgb(0, 0, 0)
        }
        .info-price {
            height: 21px;
            line-height: 21px;
            color: rgb(93, 100, 103);
            font-size:14px;
            margin-top: 14px;
            padding: 0 14px;
            img {
                width: 18px;
                height: 18px;
                border-radius: 50%;
                margin-right: 5px;
                vertical-align: middle;
            }
            span {
                display: inline-block;
            }
            .seePriceInfo {
                float: right;
                width: 109px;
                height: 26px;
                line-height: 26px;
                background: rgb(236, 33, 45);
                border-radius: 2px;
                color: #fff;
                text-align: center;
                margin-top: -3px;
            }
        }
    }
}
.container .el-image {
  margin-right: 10px;
}
.imgbox {
  position: relative;
  display: inline-block;
  width: 180px;
  margin-bottom: 10px;
  margin-right: 20px;
  .icon {
    position: absolute;
    top: 10px;
    right: -15px;
    color: red;
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
.el-dialog__body {
  padding: 30px 20px 0;
}
.el-dialog__header {
  text-align: center;
  background: #2db0a0;
  .el-dialog__title {
    color: #fff;
  }
}
.el-dialog__footer {
  text-align: center;
}
.container {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 10px 30px;
  padding-bottom: 33px;
  overflow-y: scroll;
  .header {
    width: 100%;
    height: 36px;
    background: #ec212d;
    font-size: 16px;
    color: #ffffff;
    line-height: 36px;
    padding: 0 10px;
  }
  .issueButton {
    width: 220px;
    height: 46px;
    background: #ec212d;
    border-radius: 2px;
    margin: 20px auto;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    text-align: center;
    line-height: 46px;
    color: #ffffff;
    cursor: pointer;
  }
  .timeselect {
      .el-input__inner {
          height: 40px !important;
      }
    width: 100%;
    padding-top: 20px;
    .quotation {
      width: 100%;
      display: inline-block;
      padding-right: 20px;
      .el-select {
          width: 100%;
      }
    }
    .timeStatus {
        width: 100%;
      display: inline-block;
      padding-right: 20px;
      .el-select {
          width: 100%;
      }
    }
    .maiTime {
        width: 100%;
      display: inline-block;
      padding-right: 20px;
      .el-date-editor {
          width: 100%;
      }
      .el-button {
          background-color: #ec212d;
          color: #fff;
          border-color: #ec212d;
          border-radius: 5px;
      }
    }
  }
  .productList {
    width: 100%;
    background: #ffffff;
    border: 1px solid #cdcdcd;
    border-radius: 5px;
    margin-top: 20px;
    .publisher {
      height: 28px;
      background: #f5f5f5;
      font-size: 12px;
      color: #999999;
      line-height: 28px;
      padding: 0 90px 0 17px;
      display: flex;
      justify-content: space-between;
      position: relative;
      img {
        position: absolute;
        top: 0px;
        right: 0px;
        width: 84px;
        height: 84px;
      }
    }
    .poductTab {
      .shopName {
        font-size: 12px;
        font-family: SimSun;
        font-weight: 400;
        text-decoration: underline;
        cursor: pointer;
        color: #2475ea;
      }
    }
  }
  .buyContent {
    padding: 20px 10px 0 10px;

    .content {
      font-size: 18px;
      color: #333333;
      padding-left: 7px;
    }
    .shopImg {
      margin-left: 36px;
      margin-top: 10px;
      img {
        width: 80px;
        height: 80px;
      }
    }
    .contact {
      border-top: 1px dashed #ccc;
      font-size: 14px;
      color: #333333;
      line-height: 38px;
      display: flex;
      justify-content: space-between;
      .isTabButton {
        display: inline;
        margin-left: 13px;
        width: 22px;
        height: 22px;
        background: #f1f1f1;
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.2);
        border-radius: 2px;
        text-align: center;
        line-height: 22px;
      }
    }
  }
  .el-table--border {
    border: 1px solid #ec212d;
  }
}
.el-dialog__header {
  background-color: #ec212d;
}
.el-dialog__title {
  color: #fff;
}
.el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
.el-date-editor {
  .el-input__prefix {
    left: initial;
    right: 10px;
    .el-input__icon {
    }
  }
}
.el-input--prefix .el-input__inner {
  padding-left: 15px;
}
label {
  font-weight: 400;
}
.el-upload {
  .uploadDiv {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .svg-icon {
      width: 39px;
      height: 33px;
    }
    .uploadText {
      font-size: 12px;
      font-family: SimSun;
      font-weight: 400;
      color: #d2d2d2;
      line-height: 30px;
    }
  }
}
</style>
